import authService from './auth';

/**
 * 刪除用戶（管理員專用）
 */
export const deleteUser = async (email: string): Promise<void> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${import.meta.env.VITE_API_URL}/api/users/${encodeURIComponent(email)}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Failed to delete user');
    }
};

export default {
    ...authService,
    deleteUser,
};
